<div class="row" *ngIf="!loading">
 <div class="col-sm-8">
   <blockquote>
    {{quote.body}}
    <cite> {{quote.author}}<span *ngIf="quote.source!=null">, {{quote.source}}</span> </cite>
    </blockquote>

    </div>
    <div class="col-sm-4">
       <div class="imagequote">
        <img src="/assets/images/quotes/image{{ quote.imagePosition }}.png" width="200">
        </div>
    </div>
</div>
